import * as React from "react";
const SvgHomeIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.8 20.938v-6.31h4.4v6.31h5.5v-8.412H23L12 3.063 1 12.526h3.3v8.412z" }));
export default SvgHomeIcon;
